const GLOBAL_COLUMNS = [
  { header: { en: 'firstname', es: 'nombre', 'pt-br': 'nome' } },
  { header: { en: 'surname', es: 'apellido', 'pt-br': 'sobrenome' } },
  { header: { en: 'birthday', es: 'fecha_de_nacimiento', 'pt-br': 'data_de_nascimento' } },
  { header: { en: 'telephone', es: 'telefono', 'pt-br': 'telefone' } },
  { header: { en: 'email', es: 'email', 'pt-br': 'email' } },
  { header: { en: 'medical_record_number', es: 'informe_medico', 'pt-br': 'prontuario' } },
  { header: { en: 'identification_document_1', es: 'registro_nacional_de_la_salud', 'pt-br': 'cns' } },
  { header: { en: 'identification_document_2', es: 'documento_de_identidad', 'pt-br': 'rg' } },
  { header: { en: 'identification_document_3', es: 'certificado_de_nacimiento', 'pt-br': 'cpf' } },
  { header: { en: 'identification_document_4', es: 'otro_documento', 'pt-br': 'certidao_nascimento' } },
  { header: { en: 'gender', es: 'genero', 'pt-br': 'genero' }, instructionKey: 'csv.gender' },
  { header: { en: 'mother_name', es: 'nombre_madre', 'pt-br': 'nome_mae' }, instructionKey: 'csv.mother_name' },
  { header: { en: 'address', es: 'direccion', 'pt-br': 'endereco' }, instructionKey: 'csv.address' },
  { header: { en: 'address_number', es: 'numero_direccion', 'pt-br': 'numero_endereco' }, instructionKey: 'csv.address_number' },
  { header: { en: 'neighborhood', es: 'barrio', 'pt-br': 'bairro' }, instructionKey: 'csv.neighborhood' },
  { header: { en: 'city', es: 'ciudad', 'pt-br': 'cidade' }, instructionKey: 'csv.city' },
  { header: { en: 'state', es: 'estado', 'pt-br': 'estado' }, instructionKey: 'csv.state' },
  { header: { en: 'others', es: 'otros', 'pt-br': 'outros' }, instructionKey: 'csv.others' },
]

const NOT_GLOBAL_COLUMNS = [
  { header: { en: 'firstname', es: 'nombre', 'pt-br': 'nome' } },
  { header: { en: 'surname', es: 'apellido', 'pt-br': 'sobrenome' } },
  { header: { en: 'birthday', es: 'fecha_de_nacimiento', 'pt-br': 'data_de_nascimento' } },
  { header: { en: 'telephone', es: 'telefono', 'pt-br': 'telefone' } },
  { header: { en: 'healthcare_plan', es: 'healthcare_plan', 'pt-br': 'healthcare_plan' }, instructionKey: 'csv.healthcarePlan' },
  { header: { en: 'email', es: 'email', 'pt-br': 'email' } },
  { header: { en: 'medical_record_number', es: 'informe_medico', 'pt-br': 'prontuario' } },
  { header: { en: 'identification_document_1', es: 'registro_nacional_de_la_salud', 'pt-br': 'cns' } },
  { header: { en: 'identification_document_2', es: 'documento_de_identidad', 'pt-br': 'rg' } },
  { header: { en: 'identification_document_3', es: 'certificado_de_nacimiento', 'pt-br': 'cpf' } },
  { header: { en: 'identification_document_4', es: 'otro_documento', 'pt-br': 'certidao_nascimento' } },
]

function getCsvImportColumns(isGlobalClient) {
  return isGlobalClient ? GLOBAL_COLUMNS : NOT_GLOBAL_COLUMNS
}

export function getCsvHeaderRow(locale, isGlobalClient) {
  return getCsvImportColumns(isGlobalClient).map(column => column.header[locale] || column.header.en)
}

export function getCsvInstructionKeys(isGlobalClient) {
  return getCsvImportColumns(isGlobalClient).map(column => column.instructionKey).filter(Boolean)
}
